var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select_btns"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:['btn_item', _vm.current.value === item.value && _vm.type, _vm.size],on:{"click":function($event){return _vm.selectItem(item.value)}}},[_vm._v(" "+_vm._s(item.lable)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }